<template>
  <vs-dropdown v-if="show" vs-trigger-click>
    <a href="#" class="flex items-center">
      Exportar
      <vs-icon class="ml-1" icon="expand_more"></vs-icon>
    </a>

    <vs-dropdown-menu>
      <vs-dropdown-item
        v-for="(item,index) in todosTipos"
        :key="index"
        href="#"
        v-on:click="exportar(item.tipo)"
      >{{ item.descricao }}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import api from "../services/api-service";
export default {
  name: "botao-exportar",
  props: {
    tipos: {
      required: true,
      type: Array
    },
    endpoint: {
      required: true,
      type: String
    },
    getParams: {
      required: true,
      type: Function
    }
  },
  data() {
    return {
      show: false,
      todosTipos: [
        {
          tipo: "csv",
          descricao: "Exportar como .CSV"
        }
      ]
    };
  },
  created() {
    if (this.existeTipos()) {
      this.show = true;
    }
  },
  methods: {
    existeTipos() {
      let tipos = this.todosTipos.filter(item => {
        return this.tipos.indexOf(item.tipo) !== -1;
      });

      return tipos.length > 0;
    },
    exportar(tipo) {
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirmação",
        text: "Você realmente deseja exportar esse relatório?",
        cancelText: "Cancelar",
        acceptText: "Exportar",
        accept: () => {
          this.$vs.loading();

          let params = {
            ...this.getParams(),
            exportar: tipo
          };

          api()
            .get(this.endpoint, { params })
            .then(response => {
              let fileURL = window.URL.createObjectURL(
                new Blob([response.data])
              );
              let fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", response.headers.filename);
              document.body.appendChild(fileLink);
              fileLink.click();
              fileLink.remove();
              this.$vs.loading.close();
            });
        }
      });
    }
  }
};
</script>

